document.addEventListener('DOMContentLoaded', function() {
  // Toggle mobile menu
  const navbarToggle = document.querySelector('.navbar-toggle');
  const navbar = document.querySelector('.navbar');

  if (navbarToggle) {
    navbarToggle.addEventListener('click', function() {
      navbar.classList.toggle('active');
      document.body.classList.toggle('no-scroll');
    });
  }

  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    if (navbar.classList.contains('active') && !navbar.contains(e.target)) {
      navbar.classList.remove('active');
      document.body.classList.remove('no-scroll');
    }
  });

  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth > 992) {
      navbar.classList.remove('active');
      document.body.classList.remove('no-scroll');
    }
  });

  // No need for mobile dropdown interactions as we're showing all items
});